export default {
    data: function () {
        return {
            taskId: null,
            downloaded: false,
            downloadUrl: null,
        }
    },

    watch: {
        taskId(newValue) {
            if (!newValue) {
                this.downloaded = false;
            }
        },
    },

    methods: {
        markAsDownloaded() {
            if (!this.downloaded && (this.taskId !== null)) {
                axios({
                    method: 'POST',
                    url: '/task/mark-downloaded/' + this.taskId,
                }).then(() => {
                    this.downloaded = true;
                    // this.forceDownloadByUrl(this.downloadUrl);
                });
            }

            return true;
        },

        forceDownloadByUrl(url) {
            const link = document.createElement('a');
            const filename = url.substring(url.lastIndexOf('/')+1);

            link.href = url;
            link.target = '_blank';
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();

            link.remove();
        }
    },
}
